<div class="body" *transloco="let t">
  <div class="upper-body">
    <div class="region-header">
      <div class="region-font">{{ t('AUDIT-SETUP-PAGE.REGION-VIEW.HEADER.TITLE') }}</div>
      <div class="small-head-type">{{ t('AUDIT-SETUP-PAGE.REGION-VIEW.HEADER.SUBTITLE') }}</div>
    </div>
    <div class="four-question-container">
      <div class="burnt-parameter-container">
        <div class="purple-desc">{{ t('AUDIT-SETUP-PAGE.REGION-VIEW.LABELS.SITE') }}</div>
        <div class="description">RBHU</div>
      </div>
      <div class="burnt-parameter-container">
        <div class="purple-desc">{{ t('AUDIT-SETUP-PAGE.REGION-VIEW.LABELS.SITE-SECTION') }}</div>
        <div class="description">ECB</div>
      </div>
      <app-input-select
        [label]="t('AUDIT-SETUP-PAGE.REGION-VIEW.LABELS.AREA')"
        [hint]="t('AUDIT-SETUP-PAGE.REGION-VIEW.HINTS.AREA')"
        [options]="areaOptions"
        [formGroup]="areaFormGroup"></app-input-select>
      <app-input-select
        [label]="t('AUDIT-SETUP-PAGE.REGION-VIEW.LABELS.LOCATION')"
        [hint]="t('AUDIT-SETUP-PAGE.REGION-VIEW.HINTS.LOCATION')"
        [options]="locationOptions"
        [formGroup]="locationFormGroup"></app-input-select>
    </div>
  </div>
</div>
